// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"3b53517f","632":"f4fd9305","845":"a753f19e"}[chunkId] + ".chunk.css";
};